import React, { lazy, Suspense } from 'react';
import { RoomLayout as RoomLayoutEnum } from '../../../enums/RoomLayout';
import { RoomLayoutProps } from './types';

const SingleContent = lazy(() => import('./SingleContent/SingleContent'));
const Story2Columns = lazy(() => import('./Story/Story2Columns'));
const Story3Columns = lazy(() => import('./Story/Story3Columns'));
const Tiles2Columns = lazy(() => import('./Tiles/Tiles2Columns'));
const Tiles3Columns = lazy(() => import('./Tiles/Tiles3Columns'));

interface Props extends RoomLayoutProps {
  layout: RoomLayoutEnum;
}

const RoomLayout: React.FC<Props> = (props: Props): JSX.Element => {
  const { layout, ...layoutProps } = props;

  let Component: React.FC<RoomLayoutProps>;

  switch (layout) {
    case RoomLayoutEnum.Tiles:
      Component = Tiles2Columns;
      break;
    case RoomLayoutEnum.Tiles3Columns:
      Component = Tiles3Columns;
      break;
    case RoomLayoutEnum.Story2Columns:
      Component = Story2Columns;
      break;
    case RoomLayoutEnum.SingleContent:
      Component = SingleContent;
      break;
    default:
      Component = Story3Columns;
  }

  return (
    <Suspense fallback={<></>}>
      <Component {...layoutProps} />
    </Suspense>
  );
};

export default RoomLayout;
